import React from "react";
import { toast } from "sonner";

export function SponsorsBar({ sponsors }) {
  return (
    <section
      data-testid="sponsors-bar"
      className="flex flex-wrap items-center justify-between gap-x-8 gap-y-4 border-t border-border py-6"
    >
      <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">
        Sponsored
      </span>
      <div className="flex flex-1 flex-wrap items-center justify-center gap-x-10 gap-y-4">
        {sponsors.map((brand) => (
          <span
            key={brand}
            className="select-none font-heading text-lg font-extrabold tracking-wide text-slate-300 grayscale transition-colors duration-200 hover:text-slate-400"
          >
            {brand}
          </span>
        ))}
      </div>
      <button
        data-testid="become-sponsor"
        onClick={() =>
          toast.info("Sponsorships (demo)", {
            description: "Partner onboarding connects later.",
          })
        }
        className="text-sm font-semibold text-brand hover:text-brand-hover"
      >
        Become a sponsor
      </button>
    </section>
  );
}

export default SponsorsBar;
